import { Pipe, PipeTransform } from '@angular/core';
import { MenuModel } from '../models/menu.model';

@Pipe({
  name: 'menu',
  pure: false
})
export class MenuPipe implements PipeTransform {
  transform(items: MenuModel[], condition: boolean): any {
    if (condition)
      return items.filter(item => item.routerLink && item.visible);
    else
      return items.filter(item => !item.routerLink && item.visible);
  }
}
